import { render, staticRenderFns } from "./ChartBankMovements.vue?vue&type=template&id=7a72128c&scoped=true"
import script from "./ChartBankMovements.vue?vue&type=script&lang=js"
export * from "./ChartBankMovements.vue?vue&type=script&lang=js"
import style0 from "./ChartBankMovements.vue?vue&type=style&index=0&id=7a72128c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72128c",
  null
  
)

export default component.exports